import React from "react";
import { ExternalLink } from "lucide-react";

// Carrier tracking pages — picked from the stored carrier when known,
// otherwise guessed from the number's shape; universal fallback last.
const CARRIER_URLS = {
  ups: (n) => `https://www.ups.com/track?loc=en_US&tracknum=${n}`,
  fedex: (n) => `https://www.fedex.com/fedextrack/?trknbr=${n}`,
  usps: (n) => `https://tools.usps.com/go/TrackConfirmAction?tLabels=${n}`,
  canada_post: (n) => `https://www.canadapost-postescanada.ca/track-reperage/en#/search?searchFor=${n}`,
  dhl: (n) => `https://www.dhl.com/en/express/tracking.html?AWB=${n}`,
  purolator: (n) => `https://www.purolator.com/en/shipping/tracker?pin=${n}`,
};

function carrierKey(carrier) {
  const c = (carrier || "").toLowerCase();
  if (!c) return null;
  if (c.includes("ups")) return "ups";
  if (c.includes("fedex")) return "fedex";
  if (c.includes("usps") || c.includes("stamps")) return "usps";
  if (c.includes("canada")) return "canada_post";
  if (c.includes("dhl")) return "dhl";
  if (c.includes("purolator")) return "purolator";
  return null;
}

function guessCarrier(n) {
  if (/^1Z[0-9A-Z]{16}$/i.test(n)) return "ups";
  if (/^(9[1-5])\d{18,20}$/.test(n)) return "usps";
  if (/^\d{16}$/.test(n)) return "canada_post";
  if (/^\d{12}$|^\d{15}$|^\d{20}$|^\d{22}$/.test(n)) return "fedex";
  if (/^\d{10}$/.test(n)) return "dhl";
  return null;
}

export function trackingUrl(number, carrier) {
  const n = String(number || "").replace(/\s+/g, "").trim();
  if (!n) return null;
  const key = carrierKey(carrier) || guessCarrier(n);
  return key ? CARRIER_URLS[key](encodeURIComponent(n)) : `https://parcelsapp.com/en/tracking/${encodeURIComponent(n)}`;
}

// Tracking number rendered as a "track this package" link (new tab).
export function TrackingLink({ number, carrier, className = "", testid, showIcon = true, children }) {
  const url = trackingUrl(number, carrier);
  if (!url) return <span className={className}>—</span>;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
      data-testid={testid}
      title={`Track ${number}`}
      className={`inline-flex items-center gap-1 underline decoration-dotted underline-offset-2 hover:decoration-solid hover:text-sky-700 ${className}`}
    >
      {children || number}
      {showIcon && <ExternalLink size={11} className="opacity-60 shrink-0" />}
    </a>
  );
}
